var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0934 14.4132C11.5067 14.5866 10.8134 14.6666 10.0001 14.6666H6.00007C5.18674 14.6666 4.49341 14.5866 3.90674 14.4132C4.0534 12.6799 5.8334 11.3132 8.00007 11.3132C10.1667 11.3132 11.9467 12.6799 12.0934 14.4132Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 1.33325H6.00016C2.66683 1.33325 1.3335 2.66659 1.3335 5.99992V9.99992C1.3335 12.5199 2.0935 13.8999 3.90683 14.4132C4.0535 12.6799 5.8335 11.3132 8.00016 11.3132C10.1668 11.3132 11.9468 12.6799 12.0935 14.4132C13.9068 13.8999 14.6668 12.5199 14.6668 9.99992V5.99992C14.6668 2.66659 13.3335 1.33325 10.0002 1.33325ZM8.00016 9.44657C6.68016 9.44657 5.6135 8.37326 5.6135 7.05326C5.6135 5.73326 6.68016 4.66659 8.00016 4.66659C9.32016 4.66659 10.3868 5.73326 10.3868 7.05326C10.3868 8.37326 9.32016 9.44657 8.00016 9.44657Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3866 7.05343C10.3866 8.37343 9.31995 9.44674 7.99995 9.44674C6.67995 9.44674 5.61328 8.37343 5.61328 7.05343C5.61328 5.73343 6.67995 4.66675 7.99995 4.66675C9.31995 4.66675 10.3866 5.73343 10.3866 7.05343Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerList);
export default __webpack_public_path__ + "static/media/CustomerList.027a30adfe21c2dafe134ddcd2e5468f.svg";
export { ForwardRef as ReactComponent };